window.EntregaNotaFiscalSaidaController = ControllerBase.extend({
    name: 'EntregaNotaFiscalSaidaController',
    framework: 'knockout',

    //dataBreadcrumb: new DataBreadcrumb({
    //    columns: [
    //        { title: 'Filial', prop: 'DescricaoFilial' },
    //        { title: 'Nota', prop: 'Numero' },
    //        { title: 'Série', prop: 'Serie' },
    //        { title: 'Emissão', prop: 'DataEmissao', type: 'Date' },
    //        { title: 'Valor', prop: 'ValorTotal', type: 'Money' },
    //        { title: 'Entrega', prop: 'DescricaoTipoEntrega' }
    //    ],
    //    getData: function () {
    //        return this.nf;
    //    },
    //}),

    ajax: function() {
        return {
            url: '/NotaFiscalSaida/_Entrega',
            type: 'post',
            data: {
                codigoNotaFiscal: this.notaFiscal.Codigo()
            }
        };
    }
});